//angular imports
import { ChangeDetectionStrategy, Component } from "@angular/core";

//local imports
import {
  CloseDialogMessage,
  CommandModel,
  Messenger,
} from "@app/shared";
import {
  RoomGroupDetails,
} from "@app/catalog";

@Component({
  selector: 'add-room-group',
  standalone: false,
  templateUrl: './add-room-group.component.html',
  styleUrl: './add-room-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddRoomGroupComponent {
  public details = RoomGroupDetails.empty();

  public cancelCommand = new CommandModel({
    executeAction: () => {
      this.messenger.send(new CloseDialogMessage());
      return Promise.resolve();
    },
  });

  public submitCommand = new CommandModel({
    executeAction: () => this.save(),
    isValid: this.details.isValid,
  });

  constructor(
    private messenger: Messenger,
  ) {}

  private save = async () => {};
}
